/**
 * Router Configuration
 * 
 * Centralized route definitions for the application.
 * Maps URL paths to page components with routing options.
 * 
 * Interactions:
 * - Consumed by the main Router component for route setup
 * - Defines path patterns, exact matching, and component mapping
 * - Supports multiple path aliases for the same component
 * - Enables easy addition/modification of application routes
 * - Works with React Router's dynamic component loading system
 */

const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: ["/services"],
    exact: true,
    component: "Services",
  },
];

export default routes;

